import { Dialog } from '@angular/cdk/dialog';
import { inject, Injectable } from '@angular/core';
import { OiqApplicationAddStore } from '@v2/modules/applications/components/add/add-application.store';
import { OiqAttachmentsUploadStore } from '@v2shared/components/attachments/attachments-upload.store';
import { OiqApplicationAddComponent } from './add-application.component';

@Injectable({
  providedIn: 'root',
})
export class OiqApplicationAddDialog {
  private _dialog = inject(Dialog);
  open(opts: {
    mode: 'application' | 'upload';
    panelClass?: string;
    formData?: any;
    applicationStore: OiqApplicationAddStore;
    attachmentsStore: OiqAttachmentsUploadStore;
  }) {
    return this._dialog.open(OiqApplicationAddComponent, {
      panelClass: [
        'oiq-application-add-dialog',
        opts.panelClass || 'oiq-application-add-dialog--regular',
      ],
      data: {
        mode: opts.mode,
        initialData: opts.formData,
      },
      // width: '1320px',
      maxWidth: '100%',
      providers: [
        {
          provide: OiqApplicationAddStore,
          useValue: opts.applicationStore,
        },
        {
          provide: OiqAttachmentsUploadStore,
          useValue: opts.attachmentsStore,
        },
      ],
    });
  }

  upload(opts: {
    panelClass?: string;
    applicationStore: OiqApplicationAddStore;
    attachmentsStore: OiqAttachmentsUploadStore;
  }) {
    return this._dialog.open(OiqApplicationAddComponent, {
      panelClass: [
        'oiq-application-add-dialog',
        opts.panelClass || 'oiq-application-add-dialog--regular',
      ],
      data: opts,
      // width: '1020px',
      maxWidth: '100%',
      providers: [
        {
          provide: OiqApplicationAddStore,
          useValue: opts.applicationStore,
        },
        {
          provide: OiqAttachmentsUploadStore,
          useValue: opts.attachmentsStore,
        },
      ],
    });
  }
}
